export class ServiceList {
  id: string="00000000-0000-0000-0000-000000000000";
  masterServiceCode: string;
  masterServiceModifier1: string;
  masterServiceModifier2: string;
  masterServiceModifier3: string;
  masterServiceModifier4: string;
  masterServiceName: string;
  serviceDescription: string;
  statusLid: string="00000000-0000-0000-0000-000000000000";
  billingLid: number | null;
  billingLidNmae: string;
  ratio: number;
  unitrate: number;
  netRate: number;
  agencyId: number | null;
  is837I:boolean=false;
  isHousing: boolean=false;
  serviceTypeLid: string;
}

export class ActivityList {
  id: string="00000000-0000-0000-0000-000000000000";
  masterActivityCode: string;
  masterActivityName: string;
  statusLid: string;
  agencyId: number | null;
}

export class ServiceActivityList {
  id: string="00000000-0000-0000-0000-000000000000";
  masterActivityCode: string;
  masterServiceId: string;
  masterServiceName: string | null;
  agencyId: number | null;
}

export class sortingObj {
  itemperpage: number = 20;
  currentPgNo: number = 1;
  shortcolumn: string = "MasterServiceName";
  shortType: string = 'asc';
}

export class DropList {
  label: string;
  value: string;
}export class LovDropDownBO {
  id: string;
  lovName: string;
  lovCode: string;
  lovValue: string;
}


export class functionpermission {
  servicecreate: boolean = true;
  serviceupdate: boolean = true;
  servicedelete: boolean = true;
  activitycreate: boolean = true;
  activityupdate: boolean = true;
  activitydelete: boolean = true;
  masterserviceactivitycreate: boolean = true;
  masterserviceactivityupdate: boolean = true;
  //masterserviceactivitydelete:boolean=true;
}

export class WhereCondition {
  field: string = "MasterServiceName";
  value: string = "";
  operator: string = "startswith";
  orderNo: number = 1;
  predicate: string = "and";
  type: string = "string";
  matchCase: boolean = false;
}
export class GetMSListBo {
  SearchColumn: string = "MasterServiceName";
  SearchText: string = "";
  orderColumn: string = "MasterServiceName";
  orderType: string = "asc";
  pageitem: number = 10;
  currentpageno: number = 1;
  userId: string="00000000-0000-0000-0000-000000000000";
  field: string = "MasterServiceName";
  value: string = "";
  matchCase: boolean = false;
  operator: string = "startswith";
  agencyId:  string="00000000-0000-0000-0000-000000000000";
  LovCode: string;
  type: string = "string";
}
export class GetMAListBo {
  SearchColumn: string = "MasterActivityName";
  SearchText: string = "";
  orderColumn: string = "MasterActivityName";
  orderType: string = "asc";
  pageitem: number = 10;
  currentpageno: number = 1;
  userId: string="00000000-0000-0000-0000-000000000000";
  field: string = "MasterActivityName";
  value: string = "";
  matchCase: boolean = false;
  operator: string = "startswith";
  agencyId: string="00000000-0000-0000-0000-000000000000";
  LovCode: string;
  type: string = "string";
}
export class GetPLCListBo {
  SearchColumn: string = "Service";
  SearchText: string = "";
  orderColumn: string = "Service";
  orderType: string = "asc";
  pageitem: number = 10;
  currentpageno: number = 1;
  userId: number = 0;
  field: string = "Service";
  value: string = "";
  matchCase: boolean = false;
  operator: string = "startswith";
  agencyId: number = 0;
  LovCode: string;
  type: string = "string";
}
export class GetMSAListBo {
  SearchColumn: string = "MasterServiceName";
  SearchText: string = "";
  orderColumn: string = "MasterServiceName";
  orderType: string = "asc";
  pageitem: number = 10;
  currentpageno: number = 1;
  userId: number = 0;
  field: string = "MasterServiceName";
  value: string = "";
  matchCase: boolean = false;
  operator: string = "startswith";
  agencyId: number = 0;
  LovCode: string;
  type: string = "string";
}

export class ServiceGroupMappingBO {
  agencyId: number | null;
  id: string;
  masterServiceId: any;
  serviceGroupId: number;
  masterServiceName: string;
  serviceGroupName: string;
}

export class GetSGBO {
  SearchColumn: string = "MasterServiceName";
  SearchText: string = "";
  orderColumn: string = "MasterServiceName";
  orderType: string = "asc";
  pageitem: number = 10;
  currentpageno: number = 1;
  userId: number = 0;
  field: string = "MasterServiceName";
  value: string = "";
  matchCase: boolean = false;
  operator: string = "startswith";
  agencyId: number = 0;
  LovCode: number = 0;
  type: string = "string";
  groupId: number;
  serviceCode: string;
}
export class columnWidth {
  column: string = "";
  width: number = 0;
}

export class ColumnChangeBO {
  id: number = 0;
  userid: number = 0;
  agencyId: number = 0;
  column: string;
}

export class GetListBO {
  spendownfilter: boolean | null;
  ptype: number | null;
  role: string;
  user: number | null;
  menuID: number | null;
  parentMenuID: number | null;
  searchColumn: string;
  searchText: string;
  orderColumn: string;
  orderType: string;
  pageitem: number;
  currentpageno: number;
  agencyID: number | null;
  listId: number | null;
  lovCode: number | null;
  userId: number | null;
  field: string;
  value: string;
  matchCase: boolean;
  operator: string;
  type: string;
  isEvv: boolean;
}

export class PaylocityBO {
  id: number;
  agencyId: number;
  masterServiceId: number;
  paylocityName: string;
}
export class ServiceGroupBO {
  id: number;
  name: string;
  defaultMasterServiceId: number;
  agencyId: number;
  defaultMasterServiceName: string;
}
export class GroupServiceMapBO {
  id: number=0;
  agencyId: number | null;
  serviceGroupId: number;
  serviceGroupName: string;
  masterServiceId: number=0;
  masterServiceName: string="";
  serviceCode: string;
}
export class UpdateServiceGroupBO {
  serviceGroupId: number;
  masterServiceIds: number[];
}
export class QpServicesList {
    // id:number;
    agencyId:number;
    masterServiceId:any[];
}
